import { createContext } from "react"


export const ParallaxContext = createContext()
